import { Flex, Grid, Space, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './Location.module.css';
import { partnerLocations } from './constants';
import { OpenMapBtn } from './OpenMapBtn';

export const PartnerPharmacies = () => {
  const { t } = useTranslation('landingpage');
  if (partnerLocations.length === 0) {
    return (
      <Flex
        className={classes.locationsContainer}
        bg="#fff"
        p="20px"
        align="center"
        justify="center"
      >
        <Text className={classes.locationDesc} ta="center">
          {t('Locations.PartnerLocationsComingSoon')}
        </Text>
      </Flex>
    );
  }

  return (
    <Flex className={classes.locationsContainer} bg="#fff">
      <Grid w="100%" gutter="25px">
        {partnerLocations.map((location, index) => (
          <Grid.Col key={index} span={{ sm: 6, md: 4, lg: 4 }}>
            <Flex direction="column" gap="4px">
              <Text className={classes.partnerLocationTitle}>
                {location.name}
              </Text>
              <Flex direction="column">
                <Text className={classes.locationDesc}>{location.street}</Text>
                <Text className={classes.locationDesc}>{location.city}</Text>
              </Flex>
              <Space />
              <OpenMapBtn link={location.mapLink} />
            </Flex>
          </Grid.Col>
        ))}
      </Grid>
    </Flex>
  );
};
